import { EntityId, PayloadAction, createSlice } from '@reduxjs/toolkit';
import { currentClientFavoriteApi } from '../api';
import { REDUCER_PATH } from '../lib/const';
import { FavoritesState } from './types';

const initialState: FavoritesState = [];
export type FavoritesReducerStateShape = { [REDUCER_PATH]: FavoritesState };

export const slice = createSlice({
  name: REDUCER_PATH,
  initialState,
  reducers: {
    toggleFavorite: (state, action: PayloadAction<EntityId>) => {
      const clientId = action.payload;
      if (state.includes(clientId)) {
        return state.filter((id) => id !== clientId);
      }
      state.push(clientId);
    },
    clearFavorites: () => [],
  },
  extraReducers: (builder) => {
    builder.addMatcher(currentClientFavoriteApi.endpoints.getFavoriteClientsList.matchFulfilled, (_, { payload }) => {
      return payload.map((clientProfile) => clientProfile.id);
    });
  },
});

export const clientFavoritesReducerConfig = {
  [REDUCER_PATH]: slice.reducer,
};
